"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../api/webAApi");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var moment = require("moment");
var JackpotRestrictedPlayerTagsListCtl = /** @class */ (function (_super) {
    __extends(JackpotRestrictedPlayerTagsListCtl, _super);
    function JackpotRestrictedPlayerTagsListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.JP_A_TYPE_GROW = 1;
        _this.JP_A_TYPE_TRIGGER = 2;
        _this.dk_key = UIUtils_1.UIUtils.IProp2Str(function (o) { o.key; });
        _this.dk_app_usr_player_tag_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.app_usr_player_tag_id; });
        _this.dk_app_usr_player_tag_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.app_usr_player_tag_title; });
        // public readonly dk_jp_activity_type_code = UIUtils.IProp2Str((o: IJackpotPlayerTagListItem) => { o.jp_activity_type_code });
        // public readonly dk_jp_activity_type_title = UIUtils.IProp2Str((o: IJackpotPlayerTagListItem) => { o.jp_activity_type_title });
        _this.dk_date_added = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added; });
        _this._errDialog = errDialog;
        return _this;
    }
    JackpotRestrictedPlayerTagsListCtl.prototype.ResetData = function () {
        this.DATA = {
            data: [],
            total: 0
        };
    };
    JackpotRestrictedPlayerTagsListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        throw "jackpot player tag with id [" + id + "] not found !";
    };
    JackpotRestrictedPlayerTagsListCtl.prototype.LoadData = function (bonusJackpotId, onDone) {
        var _this = this;
        webAApi_1.ListBonusJackpotRestrictedPlayerTagsGet.exec({
            bonus_jackpot_id: bonusJackpotId
        }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                var tmp = {
                    key: resp.list[i].key_uid,
                    app_usr_player_tag_id: resp.list[i].app_usr_player_tag_id,
                    app_usr_player_tag_title: resp.list[i].app_usr_player_tag_title,
                    date_added: moment(resp.list[i].date_added_uts_ms).utc(false)
                };
                _this.DATA.data.push(tmp);
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    JackpotRestrictedPlayerTagsListCtl.prototype.AddData = function (data, onDone) {
        var _this = this;
        webAApi_1.DoAddBonusJackpotRestrictedPlayerTag.exec({
            data: {
                bonus_jackpot_id: data.bonus_jackpot_id,
                usr_player_tag_id: data.usr_player_tag_id,
            }
        }, function (resp) {
            var tmp = {
                key: resp.key_uid,
                date_added: moment(resp.date_added_uts_ms).utc(false),
                app_usr_player_tag_id: data.usr_player_tag_id,
                app_usr_player_tag_title: resp.usr_player_tag_title
            };
            _this.DATA.data.push(tmp);
            _this.DATA.total++;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    JackpotRestrictedPlayerTagsListCtl.prototype.RemoveItem = function (key) {
        var i_idx = -1;
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === key) {
                i_idx = i;
            }
        }
        if (i_idx > 0) {
            var rest = this.DATA.data.slice(i_idx + 1);
            this.DATA.data.length = i_idx;
            this.DATA.data.push.apply(this.DATA.data, rest);
        }
    };
    JackpotRestrictedPlayerTagsListCtl.prototype.DeleteData = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoDeleteBonusJackpotRestrictedPlayerTag.exec({ data: { bonus_jackpot_restricted_player_tag_id: key } }, function (resp) {
                _this.RemoveItem(key);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    return JackpotRestrictedPlayerTagsListCtl;
}(BaseController_1.BaseController));
exports.JackpotRestrictedPlayerTagsListCtl = JackpotRestrictedPlayerTagsListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_jackpots/ctl/JackpotRestrictedPlayerTagsListCtl.ts
// module id = 968
// module chunks = 0